import { render, staticRenderFns } from "./SetDuration.vue?vue&type=template&id=652f8591&scoped=true&"
import script from "./SetDuration.vue?vue&type=script&lang=js&"
export * from "./SetDuration.vue?vue&type=script&lang=js&"
import style0 from "./SetDuration.vue?vue&type=style&index=0&id=652f8591&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652f8591",
  null
  
)

export default component.exports